import supabaseClient from '@/api/supabaseClient.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FunctionsHttpError } from '@supabase/supabase-js';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';

export type CreateBookingRequestParams = {
  carer_id: string;
  start_date?: string;
  start_time?: string;
  end_time?: string;
  notes?: string;
};

const useCreateBookingRequest = () => {
  const queryClient = useQueryClient();

  const mutationFn = async (params: CreateBookingRequestParams) => {
    const { data, error } = await supabaseClient.functions.invoke('create_booking_request', {
      method: 'POST',
      body: params,
    });

    if (error) {
      if (error instanceof FunctionsHttpError) {
        const err: BackendErrorResponse = await error.context.json();
        throw new Error(err.errors.join(', '));
      }
      throw new Error((error as Error).message);
    }

    return data;
  };

  return useMutation({
    mutationFn,
    onSuccess: (_data, variables) => {
      // Invalidate the carer details query to refetch with updated status
      queryClient.invalidateQueries({ queryKey: ['carer', variables.carer_id] });
    },
  });
};

export default useCreateBookingRequest;
